export default __webpack_public_path__ + "static/media/Spin torre M_Interactive LightMix0059.caa08d6e.webp";